"use strict";
/** state: Final **/
/** family: TreeView **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var ReactDOM = require("react-dom");
var utils_1 = require("../utils");
var utils_2 = require("./utils");
var TreeViewItem_1 = require("../TreeViewItem");
var CLASS_NAME = 'i-tree-view';
var TreeViewDropdownType;
(function (TreeViewDropdownType) {
    TreeViewDropdownType["Caret"] = "caret";
    TreeViewDropdownType["Explorer"] = "explorer";
    TreeViewDropdownType["ExplorerLines"] = "explorer-lines";
})(TreeViewDropdownType = exports.TreeViewDropdownType || (exports.TreeViewDropdownType = {}));
/**
 * TreeViews are used to display a hierarchy in a simple view.
 */
var TreeView = /** @class */ (function (_super) {
    __extends(TreeView, _super);
    function TreeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFocus = function (e) {
            var self = ReactDOM.findDOMNode(_this);
            if (e.target === self) {
                utils_2.NavigateTree.focus(self.firstElementChild);
            }
            self.setAttribute('tabIndex', '-1');
        };
        _this.handleBlur = function () {
            ReactDOM.findDOMNode(_this).setAttribute('tabIndex', '0');
        };
        _this.injectPropsOnChildren = function () {
            return React.Children.map(_this.props.children, function (child) {
                if (utils_1.isType(child, TreeViewItem_1.TreeViewItem)) {
                    return React.cloneElement(child, {
                        dropdownType: _this.props.dropdownType || TreeViewDropdownType.Caret,
                        filterText: _this.props.filterText,
                    });
                }
                return child;
            });
        };
        return _this;
    }
    TreeView.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, dropdownType = _a.dropdownType, filterText = _a.filterText, restProps = __rest(_a, ["children", "className", "dropdownType", "filterText"]);
        var injectedChildren = this.injectPropsOnChildren();
        // Find out if tree is multiselectable by detecting checkboxProps
        // on children and then set the tree's "aria-multiselectable" property
        var ariaMultiselectable = false;
        React.Children.forEach(injectedChildren, function (child) {
            ariaMultiselectable =
                ariaMultiselectable ||
                    child.props.hasOwnProperty('checkboxProps');
        });
        var dropdownClass = dropdownType || TreeViewDropdownType.Caret;
        var classes = classNames(CLASS_NAME, className, CLASS_NAME + "-dropdown-" + dropdownClass);
        return (React.createElement("ul", __assign({ className: classes, onBlur: this.handleBlur, onFocus: this.handleFocus, role: "tree", tabIndex: 0, "aria-multiselectable": ariaMultiselectable || null }, restProps), injectedChildren));
    };
    TreeView.Item = TreeViewItem_1.TreeViewItem;
    TreeView.DropdownType = TreeViewDropdownType;
    return TreeView;
}(React.Component));
exports.TreeView = TreeView;
//# sourceMappingURL=TreeView.js.map